import React, { useEffect } from 'react';

import AppContent from 'components/common/AppContent';
import { useModal } from 'context/ModalContext';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { acceptPath } from 'shared/hooks';
import { sha256 } from 'shared/lib';
import { ChannelService } from 'shared/lib';
import { useInfoStore } from 'store/useInfoStore';
import { Footer } from 'widgets/footer';
import { AppHeader } from 'widgets/header';

const DefaultLayout = () => {
  const { pathname, search } = useLocation();
  const { accessToken, firstName, lastName, email } = useInfoStore();
  const { openModal, MODAL_TYPES } = useModal();
  const isLogin = email !== '' && firstName !== '' && lastName !== '' && accessToken !== '';
  const isAcceptPath = acceptPath.includes(pathname) || pathname.startsWith('/listing');

  useEffect(() => {
    if (!isAcceptPath && !isLogin) {
      openModal(MODAL_TYPES.LOGIN);
    }
  }, [isLogin, isAcceptPath, search, MODAL_TYPES, openModal]);

  const getGTMScript = () => {
    const baseScript = `
      window.dataLayer = window.dataLayer || [];
      ${
        isLogin
          ? `dataLayer.push({
              'user_id': '${sha256(email)}'
            });`
          : ''
      }
    `;

    const gtmScript = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-T76Z9XGF');
    `;

    return { baseScript, gtmScript };
  };

  const { baseScript, gtmScript } = getGTMScript();

  useEffect(() => {
    ChannelService.loadScript();

    ChannelService.boot({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      pluginKey: process.env.REACT_APP_CHANNEL_TALK_PLUGIN_KEY!,
    });
  }, []);

  return (
    <>
      <Helmet>
        <script>{baseScript}</script>
        {/* Google Tag Manager */}
        <script>{gtmScript}</script>
        {/* End Google Tag Manager */}
      </Helmet>
      <AppHeader />
      <AppContent />
      <Footer />
    </>
  );
};

export default DefaultLayout;
